import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { StatusBadge } from "@/components/StatusBadge";
import { fmt } from "@/lib/format";

const COLS = [["skor_performa", "Performa"], ["skor_produktivitas", "Produktivitas"], ["skor_hari_kerja", "Hari Kerja"], ["total_skor", "Total"]];

export const OfficerDialog = ({ officer, onClose }) => (
  <Dialog open={!!officer} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="officer-dialog" className="max-w-2xl">
      {officer && (
        <>
          <DialogHeader>
            <DialogTitle className="font-heading">{officer.nama}</DialogTitle>
            <DialogDescription>{[officer.id_petugas, officer.unit, officer.ulp, officer.perusahaan].filter(Boolean).join(" · ")}</DialogDescription>
          </DialogHeader>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="border-b text-left text-xs uppercase tracking-wider text-muted-foreground">
                <th className="py-2 pr-3">Bulan</th>{COLS.map(([, l]) => <th key={l} className="px-2 text-right">{l}</th>)}
                <th className="px-2 text-right">Persentase</th><th className="pl-2">Status</th>
              </tr></thead>
              <tbody>
                {officer.months.map((m) => (
                  <tr key={m.bulan_no} data-testid={`officer-month-${m.bulan_no}`} className="border-b">
                    <td className="py-2 pr-3 font-medium">{m.bulan}</td>
                    {COLS.map(([k]) => <td key={k} className="px-2 text-right font-num">{fmt(m[k], "score")}</td>)}
                    <td className="px-2 text-right font-num font-semibold">{fmt(m.persen, "pct")}</td>
                    <td className="pl-2"><StatusBadge status={m.status} /></td>
                  </tr>
                ))}
                <tr data-testid="officer-average-row" className="bg-muted/50 font-semibold">
                  <td className="py-2 pr-3">Rata-rata</td>
                  {COLS.map(([k]) => <td key={k} className="px-2 text-right font-num">{fmt(officer[k], "score")}</td>)}
                  <td className="px-2 text-right font-num">{fmt(officer.persen, "pct")}</td>
                  <td className="pl-2"><StatusBadge status={officer.status} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
